import { render, staticRenderFns } from "./CreateUserProfileShow.vue?vue&type=template&id=4e48a60e&"
import script from "./CreateUserProfileShow.vue?vue&type=script&lang=js&"
export * from "./CreateUserProfileShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports